import Vue from 'vue'
import Router from 'vue-router'
import { sync } from 'vuex-router-sync'
import store from '@/store'
import routes from './routes'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: routes
})

sync(store, router)

router.beforeResolve((to, from, next) => {
    if (to.name)
    {
        store.dispatch('updateLoading', true)
    }
    next()
})

router.beforeEach((to, from, next) => {

    // Auth && Guest Guard
    if (to.matched.some(record => record.meta.requiresAuth))
    {
        if (!store.getters.authIsLoggedIn)
        {
            next({name: 'home'})
            return
        }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        if (store.getters.authIsLoggedIn)
        {
            next({name: 'home'})
            return
        }
    }

    // Load layout defined in component or fefault
    const components = router.getMatchedComponents({ ...to})
    if (components.length)
    {
        if (components && components[0])
        {
            if (typeof components[0] == 'function')
            {
                setTimeout(() => {
                    components[0]().then(component => {
                        if (component && component.default)
                            store.dispatch('setLayout', component.default.layout)
                        next()
                    })
                })
            } else {
                if (components && components[0])
                    store.dispatch('setLayout', components[0].layout || null)
                next()
            }
        }
    } else {
        store.dispatch('setLayout', null)
        next()
    }

})

router.afterEach((to, from) => {
    store.dispatch('updateLoading', false)
    if(!(to.path === from.path && Boolean(to.query.color))) window.scrollTo(0,0)
})

export default router
